<template>
	<section>

		<div class="d-flex flex-row align-items-center justify-content-between">
			<h3 v-if="isGlobalServiceTasks" class="mb-0">Service Tasks</h3>
			<h3 v-else class="mb-0">Tasks from Contract Schedule</h3>

			<div v-if="!isFinalized">
				<button class="btn btn-success" v-on:click="newTask">
					<i class="fa fa-plus"></i>
					Add Task
				</button>

				<button v-if="!hideRegenButton" class="btn btn-light" titile="Regenerate Tasks" v-on:click="confirmRegen">
					<i class="fa fa-sync"></i>
				</button>
			</div>
		</div>

		<table-list
			record-name="Task"
			:fields="taskFields"
			:records="mutatedTasks"
			:has-edit="!isFinalized"
			:has-delete="!isFinalized"
			:hide-record-count="true"
			v-on:edit="editTask"
			v-on:delete="deleteObject($event,'ServiceInvoiceObject')">

		</table-list>

		<modal-dialog
			:modal-visible="taskEditModal.visible"
			:title="taskEditModal.title"
			confirm-button-text="Save"
			v-on:confirm="saveTaskObject"
			v-on:closeModal="taskEditModal.visible = false">

			<field label="Task Item" 
				col-class="col-md-4" 
				:params="{type:'select',options:taskOptions}" 
				v-model="taskEditModal.payload.task_id"
				v-on:change="taskSelected">
			</field>

			<field label="Price" 
				col-class="col-md-4" 
				:params="{type:'number',step: 0.01}" 
				v-model="taskEditModal.payload.unit_price">
			</field>

			<field label="QTY" 
				col-class="col-md-4" 
				:params="{type:'number',min:0,step:0.05}" 
				v-model="taskEditModal.payload.qty">
			</field>

			<field label="Unit Cost" 
				col-class="col-md-4" 
				:params="{type:taskEditModal.editingCost ? 'number' : 'number',min:0,step:0.01}" 
				v-model="taskEditModal.payload.unit_cost"
				v-on:click="taskEditModal.editingCost = true"
				v-on:change="costChanged">
			</field>

		</modal-dialog>

	</section>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"

export default {
	name: "InvoiceTasksSection",
	components: {
		Field,
		TableList,
		ModalDialog
	},
	mixins: [InvoiceMixins],
	props: ["invoiceTasks","invoiceId","typeName","hideRegenButton","isGlobalServiceTasks","isFinalized"],
	data() {
		return {
			taskFields: [
				{label: "Item Number", key: "item_number"},
				{label: "Description", key: "description"},
				{label: "QTY",key:"qty",align:"right"},
				{label: "Unit Price",key: "unitPriceFormatted",align:"right"},
				{label: "Total",key:"total",align:"right"}
			],
			serviceContractTasks: [],
			taskEditModal: {
				visible: false,
				title: "Edit Task from Contract Schedule",
				payload: {},
				lineTotal: 0,
				editingCost: false
			}
		}
	},
	watch: {
		value() {
			this.workCompletedDescription = this.value
		},
		workCompletedDescription() {
			this.$emit("input",this.workCompletedDescription)
		}
	},
	computed: {
		mutatedTasks() {

			return this.invoiceTasks.map(task => {

				let unitPriceFormatted = +task.unit_price

				task.total = parseFloat(task.qty) * parseFloat(task.unit_price)

				task.unitPriceFormatted = unitPriceFormatted.toCurrency()

				task.total = task.total.toFixed(2)

				return task
			})
		},
		taskOptions() {
			return this.optionify(this.serviceContractTasks.map(task => {
				task.displayName = task.item_number+": "+task.description

				return task
			}),"displayName")
		},
	},
	methods: {
		saveTaskObject() {
			let vm = this

			let task_id = this.taskEditModal.payload.task_id

			if (task_id) {

				//fetch fields from task list
				this.getJSON("ServiceContractTask/find/"+task_id).then(response => {

					let fields = response.data

					fields.qty = vm.taskEditModal.payload.qty
					fields.task_id = vm.taskEditModal.payload.task_id
					fields.unit_price = vm.taskEditModal.payload.unit_price
					fields.unit_cost = vm.taskEditModal.payload.unit_cost

					let postPayload = {
						id: vm.taskEditModal.payload.id,
						invoice_id: vm.taskEditModal.payload.invoice_id,
						type: "Task",
						field_values_json: JSON.stringify(fields)
					}

					vm.postData("ServiceInvoiceObject/save",postPayload).then(response => {
						//vm.fetchInvoiceData()
						vm.$emit("modelChanged")

						vm.taskEditModal.visible = false
					})
				})
			}
			else 
				vm.alertFail("Task not defined")

		},
		editTask(record) {
			let vm = this

			this.taskEditModal.visible = true
			this.taskEditModal.title = this.isGlobalServiceTasks ? "Edit Service Task" : "Edit Task from Contract Schedule"

			this.fetchServiceContractTasks().then(response => {
				vm.taskEditModal.payload = JSON.parse(JSON.stringify(record))

				console.log(vm.taskEditModal.payload)
			})
		},
		newTask() {
			this.taskEditModal.visible = true
			this.taskEditModal.title = "Add Task to "+this.typeName
			this.taskEditModal.payload = {
				invoice_id: this.invoiceId,
				type: "Task"
			}

			this.fetchServiceContractTasks()
		},
		taskSelected(taskId) {
			let theTask = this.serviceContractTasks.find(task => task.id == taskId)

			if (theTask) {
				let unitPrice = +theTask.unit_price
				this.taskEditModal.payload.unit_price = unitPrice.toFixed(2)

				let unitCost = +theTask.unit_cost
				this.taskEditModal.payload.unit_cost = unitCost.toFixed(2)
			}
		},
		costChanged(value) {
			let cost = +value

			this.taskEditModal.editingCost = false

			this.$nextTick(() => {
				this.taskEditModal.payload.unit_cost = cost.toFixed(2)
				this.$forceUpdate()
			})
		},
		fetchServiceContractTasks() {
			let vm = this

			this.spinner(true)

			return new Promise((resolve,reject) => {

				let filters = [["contract_id",0]]
				if (!vm.isGlobalServiceTasks && "ServiceContract" in vm.$store.service && vm.$store.service.ServiceContract)
					filters = [["contract_id",vm.$store.service.ServiceContract.id]]

				vm.getJSON("ServiceContractTask/get",{
					filters
				}).then(response => {

					vm.spinner(false)

					vm.serviceContractTasks = response.data

					resolve(response)
				})

			})
		}
	}
}
</script>